let backendUrl;
let frontendUrl;
let staticUrl;

if (process.env.REACT_APP_NODE_ENV == "production") {
  frontendUrl = process.env.REACT_APP_API_PRODUCTION_URL;
  staticUrl = process.env.REACT_APP_STATIC_PRODUCTION_URL;
  backendUrl = process.env.REACT_APP_BACKEND_PRODUCTION_URL;
} else if (process.env.REACT_APP_NODE_ENV == "staging") {
  frontendUrl = process.env.REACT_APP_API_STAGING_URL;
  staticUrl = process.env.REACT_APP_STATIC_STAGING_URL;
  backendUrl = process.env.REACT_APP_BACKEND_STAGING_URL;
} else if (process.env.REACT_APP_NODE_ENV == "local") {
  frontendUrl = process.env.REACT_APP_API_LOCAL_URL;
  staticUrl = process.env.REACT_APP_STATIC_LOCAL_URL;
  backendUrl = process.env.REACT_APP_BACKEND_LOCAL_URL;
} else {
  frontendUrl = process.env.REACT_APP_API_PRODUCTION_URL;
  staticUrl = process.env.REACT_APP_STATIC_PRODUCTION_URL;
  backendUrl = process.env.REACT_APP_BACKEND_PRODUCTION_URL;
}

console.log(
  "********************** process.env.REACT_APP_NODE_ENV:",
  process.env.REACT_APP_NODE_ENV
);

console.log("********************** Frontend URL:", frontendUrl);
console.log("********************** Static URL:", staticUrl);
console.log("********************** Backend URL:", backendUrl);

export { backendUrl, frontendUrl, staticUrl };
